import { gql } from 'apollo-boost';

export const SEND_SCRIPT_EMAIL = gql`
  mutation sendScriptEmail($publisherId: String!){
    sendScriptEmail(publisherId: $publisherId)
  }`;